import React, { useState, useEffect } from "react";
import { useAuth0 } from "../react-auth0-spa";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import config from "../api_config.json";
import AppLoader from "./AppLoader";
import ErrorApi from "./ErrorApi";
import GoogleDocsLogo from "../images/google_docs.png";
import Fab from "@material-ui/core/Fab";
import DocumentIcon from "@material-ui/icons/Description";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  bigAvatar: {
    width: 60,
    height: 60,
    margin: "20px auto",
  },
  title: {
    color: "#003087",
  },
  subtitle: {
    color: "#003087",
    margin: theme.spacing(1),
  },
  cardSettings: {
    "text-align": "left",
    "padding-left": theme.spacing(1),
    "padding-right": theme.spacing(1),
  },
  imgFluid: {
    "max-width": "100%",
  },
  fabBtn: {
    marginTop: theme.spacing(2),
    color: "#ffffff",
  },
}));

const Profile = () => {
  const classes = useStyles();
  const { user } = useAuth0();
  const [loading, setLoading] = useState(true);
  const [hasApiIssue, setHasApiIssue] = useState(false);
  const { isAuthenticated } = useAuth0();
  const [profile, setProfile] = useState({});

  const { getTokenSilently } = useAuth0();

  useEffect(() => {
    const callApi = async () => {
      const token = await getTokenSilently();

      const url = `${config.apiUrl[process.env.REACT_APP_ENV]}/profile`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const responseData = await response.json();
      return responseData.data;
    };

    callApi()
      .then((data) => {
        setLoading(false);
        setProfile(data);
      })
      .catch((error) => {
        console.log("TCL: Profile -> error", error);
        setLoading(false);
        setHasApiIssue(true);
      });
  }, [getTokenSilently]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  if (loading) {
    return <AppLoader />;
  }

  if (!isAuthenticated) {
    return <div></div>;
  }

  if (hasApiIssue) {
    console.log("TCL: Profile -> hasApiIssue", hasApiIssue);

    return <ErrorApi errorMessage="Cannot fetch user profile" />;
  }

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h4" className={classes.title}>
            Profile
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Avatar
                alt={user.name}
                src={user.picture}
                className={classes.bigAvatar}
              />

              <Typography
                className={classes.userDescription}
                color="textSecondary"
              >
                Spanish Student
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={8}>
          <Card className={classes.cardSettings}>
            <CardContent>
              <Typography
                className={classes.subtitle}
                color="textSecondary"
                gutterBottom
              >
                Settings
              </Typography>
              <Typography
                className={classes.userDescription}
                color="textSecondary"
              >
                Your email: {user.email}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {profile && profile.googleDocs && (
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Typography
                  className={classes.subtitle}
                  color="textSecondary"
                  gutterBottom
                >
                  Quick Links
                </Typography>

                <a
                  href={profile.googleDocs}
                  title="Google Docs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={GoogleDocsLogo}
                    alt="Google Docs"
                    className={classes.imgFluid}
                  />
                </a>
                <Typography
                  className={classes.userDescription}
                  color="textSecondary"
                >
                  This is your own Google Document for the lesson
                </Typography>

                <a
                  href={profile.googleDocs}
                  title="Google Docs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Fab
                    variant="extended"
                    color="primary"
                    aria-label="like"
                    className={classes.fabBtn}
                  >
                    <DocumentIcon className={classes.bookNowIcon} />
                    Open
                  </Fab>
                </a>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default Profile;
